package top.wcpe.allincore.layout.engine

import kotlin.jvm.JvmField

/**
 * 布局产出的二维包围盒。
 * 坐标 (x, y) 相对于父节点的内容区，单位与传入的尺寸单位一致。
 *
 * ADR-0034：保留「public final 字段 + 同名访问器」双形态（JVM 端 `@JvmField` 保字段直读，
 * 同名方法保 `x()` 式调用点），下游两种用法零改动。
 */
class Box(
    @JvmField val x: Float,
    @JvmField val y: Float,
    @JvmField val width: Float,
    @JvmField val height: Float
) {

    fun x(): Float = x

    fun y(): Float = y

    fun width(): Float = width

    fun height(): Float = height

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is Box) return false
        // 逐位比较（等价 Java Float.compare == 0）：NaN 自反相等、+0f/-0f 不相等
        return other.x.toBits() == x.toBits() &&
            other.y.toBits() == y.toBits() &&
            other.width.toBits() == width.toBits() &&
            other.height.toBits() == height.toBits()
    }

    override fun hashCode(): Int {
        // 逐位复刻原 Java Objects.hash(x, y, width, height)
        var result = 1
        result = 31 * result + x.hashCode()
        result = 31 * result + y.hashCode()
        result = 31 * result + width.hashCode()
        result = 31 * result + height.hashCode()
        return result
    }

    override fun toString(): String {
        return "Box[x=$x, y=$y, width=$width, height=$height]"
    }
}
